import { Noise } from 'noisejs';

import { GetBy } from "../_app/cuchillo/core/Element";
import { Scroll } from '../_app/cuchillo/scroll/Scroll';

export class WaveCircle {
    container;
    path;
    rect;
    speed = 0;
    noise;
    width = 0;
    height = 0;
    options = {
        frequency: Math.random() * (0.008 - 0.001) + 0.001,
        amplitude: Math.random() * (35 - 25) + 25
    };
    radius = 0;
    center = { x: 0, y: 0 };

    constructor(__svg, __opts = {}) {
        this.container = __svg;
        this.path = GetBy.class('shape', this.container)[0]; // Seleccionamos el path dentro del clipPath
        this.rect = GetBy.class('rect', this.container)[0]; // Seleccionamos el path dentro del clipPath

        this.options = {
            ...__opts,
            ...this.options,
        };

        this.noise = new Noise(Math.random());

        this.resize();
        this.generateSmoothCircleWave();
    }

    setupAttributes() {
        this.container.setAttribute('viewBox', `0 0 ${this.width} ${this.height}`);
        this.container.setAttribute('width', this.width);
        this.container.setAttribute('height', this.height);
        this.rect.setAttribute('width', this.width);
        this.rect.setAttribute('height', this.height);
    }

    calculateCircle() {
        this.radius = Math.min(this.width, this.height) / 2.4;
        this.center = { x: this.width / 2, y: this.height / 2 };
    }

    generateSmoothCircleWave() {
        let pathData = `M ${this.center.x + this.radius} ${this.center.y}`;

        for (let angle = 0; angle <= 360; angle++) {
            const radians = (angle * Math.PI) / 180;
            const noiseValue = this.noise.perlin2(angle * .034, this.speed * 0.04 + Scroll.speed * .04);
            const variableAmplitude = this.options.amplitude * (0.5 + noiseValue);

            const x = this.center.x + (this.radius + variableAmplitude) * Math.cos(radians);
            const y = this.center.y + (this.radius + variableAmplitude) * Math.sin(radians);

            pathData += `L ${x} ${y}`;
        }

        pathData += `L ${this.center.x + this.radius} ${this.center.y}`;
        this.path.setAttribute('d', pathData);
    }

    loop(__t) {
        this.speed = __t * .25;
        this.generateSmoothCircleWave();
    }

    dispose() {
        this.container = null;
        this.path = null;
    }

    resize() {
        const { height, width } = this.container.getBoundingClientRect();

        this.height = height;
        this.width = width;

        this.setupAttributes();
        this.calculateCircle();
    }
}
